// utils/TokenExpiryContext.js
import { createContext, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { clearToken } from "../utils/Authe";

const TokenExpiryContext = createContext();

export const TokenExpiryProvider = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const clientCode = sessionStorage.getItem("clientCode");
    const baseUrl = process.env.REACT_APP_API_BASE_URL;

    // Only run for STUDENT sessions
    const studentToken = sessionStorage.getItem("student_token");
    if (!studentToken) {
      console.log("No student_token found. Skipping expiry timer.");
      return; // ← EARLY RETURN: Don't run for admin!
    }

    const expiryTime = 4 * 60 * 60 * 1000 + 59 * 60 * 1000; // 7h59m

    const timer = setTimeout(async () => {
      try {
        const response = await fetch(`${baseUrl}/student/logout/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${studentToken}`,
          },
        });

        if (response.ok) {
          clearToken("student_token");
          sessionStorage.removeItem("student_id");
          sessionStorage.removeItem("student_name");
          sessionStorage.removeItem("student_email");
          navigate(`/login?client-code=${clientCode}`);
        } else {
          console.error("Student logout failed");
        }
      } catch (error) {
        console.error("Error during student logout:", error);
      }
    }, expiryTime);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <TokenExpiryContext.Provider value={{}}>
      {children}
    </TokenExpiryContext.Provider>
  );
};

export const useTokenExpiry = () => useContext(TokenExpiryContext);
